import '../sass/main.scss';
import Navigation from './navigation';
import Slider from './slider';
/* import Form from './form'; */

new Navigation();
new Slider();
/* new Form(); */